<template>
  <d2-container>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="titlebt" name="second">
        <child2 v-if="isChildUpdate2" :agentid_f2="agentid_f2" @refreshNoheader="getTableData" ></child2>

      </el-tab-pane>
      <el-tab-pane :label="titlebt2" name="third">
        <child3 v-if="isChildUpdate3" :agentid_f3="agentid_f3" @refreshNoheader="getTableData" ></child3>
      </el-tab-pane>
      <el-tab-pane :label="titlebt3" name="fourth">
        <child4 v-if="isChildUpdate4" :agentid_f4="agentid_f4" @refreshNoheader="getTableData" ></child4>
      </el-tab-pane>
    </el-tabs>

  </d2-container>
</template>
<script>
import * as agentService from '@/api/sys/agent'
import editForm from './editForm'
import util from '@/libs/util.js'
import tabZujianChild2 from './tabZujianChild2'
import tabZujianChild3 from './tabZujianChild3'
import tabZujianChild4 from './tabZujianChild4'
export default {
  name: 'PosterPage',
  components: {
    child2: tabZujianChild2,
    child3: tabZujianChild3,
    child4: tabZujianChild4
  },
  data () {
    return {
      searchForm: {
        advTitle: ''
      },
      titlebt: '',
      titlebt2: '',
      titlebt3: '',
      activeName: 'second',
      isChildUpdate2: true,
      isChildUpdate3: false,
      isChildUpdate4: false,
      agentid_f2: '',
      agentid_f3: '',
      agentid_f4: '',
      loading: false,
      oneclass: {}
    }
  },
  mounted () {
    this.agentid_f2 = util.cookies.get('agentid')
    this.agentid_f3 = util.cookies.get('agentid')
    this.agentid_f4 = util.cookies.get('agentid')
    this.getTableData()
  },
  methods: {
    getTableData () {
      var formData4 = new FormData() // 声明一个FormData对象
      formData4.append('agentid', util.cookies.get('agentid'))
      agentService.getIntegralGoodsSum(formData4).then(data => {
        if (data != null && data != '') {
          this.titlebt = '全部商品(' + data.all_sum + ')'
          this.titlebt2 = '已上架(' + data.sj_sum + ')'
          this.titlebt3 = '未上架(' + data.xj_sum + ')'
        }
      })
    },
    handleClick (tab, event) {
      console.log(tab, event)
      if (tab.name == 'second') {
        // 触发‘用户管理’事件
        this.isChildUpdate2 = true
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
      } else if (tab.name == 'third') {
        // 触发‘用户管理’事件
        this.isChildUpdate2 = false
        this.isChildUpdate3 = true
        this.isChildUpdate4 = false
      } else if (tab.name == 'fourth') {
        // 触发‘用户管理’事件
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = true
      }
    }
  }
}
</script>
